module.exports = __webpack_public_path__ + "img/2018_0.a9fface7.webp";